export const SET_FILTER_ENTRANCE = 'SET_FILTER_ENTRANCE'
export const SET_FILTER_RESET = 'SET_FILTER_RESET'

export default function filterEntrance(
    state = {
        filterEntranceData:null,
        filterEntranceLogData:null
    },action
){
    switch (action.type){
        case "SET_FILTER_ENTRANCE":
            return{
                ...state,
                filterEntranceData:action.payload
            }
        case "SET_FILTER_ENTRANCE_LOG":
            return{
                ...state,
                filterEntranceLogData:action.payload
            }
        case SET_FILTER_RESET:
            return {
                ...state, filterEntranceData: {
                    dateFrom: getTodayDateFrom(),
                    dateTo: getTodayDateTo()
                }, filterEntranceLogData: null
            }
        default:
            return state;
    }
}

const getTodayDateFrom = () => {
    let date = new Date().toISOString();
    return date.slice(0, date.indexOf("T")) + "T00:00";
}

const getTodayDateTo = () => {
    let date = new Date().toISOString();
    return date.slice(0, date.indexOf("T")) + "T23:59";
}
